"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletList = void 0;
function BulletList(props) {
    return <ul>{props.children}</ul>;
}
exports.BulletList = BulletList;
